import React from 'react';
import classNames from 'classnames';

const ApplyButton = ({
  enabled,
  onClick,
  label = t('common.apply'),
  accessible = false,
}) => {
  const styleName = classNames({
    NewButton: !accessible,
    AccessibleButton: accessible,
    'NewButton--darkNavy': true,
    'NewButton--center': true,
    'NewButton--disabled': !enabled,
    'IndexFilter-applyButton': true,
  });

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!enabled}
      className={styleName}
      onMouseDown={e => {
        // Prevents mouse click focus ring
        e.preventDefault();
      }}
    >
      {label}
    </button>
  );
};

export default ApplyButton;
